module.exports = __webpack_public_path__ + "img/Dodge.cc35414d.png";